/**
 * Revue de presse "Ils parlent de nous" — source UNIQUE partagée par
 * l'encart carrousel (PressBadge, accueil + associations) et l'espace
 * presse complet (PressPage).
 *
 * ORDRE = ordre d'affichage (le carrousel et la page suivent ce tableau, pas la
 * date). Décision Lucas (05/08/2026) : CRESS Occitanie en PREMIER (reconnaissance
 * institutionnelle ESS), puis La Tribune, TOULÉCO et le reste.
 */
export const PRESS_MENTIONS = [
  // 04/11/2026 : article NeozOne (02/11/2026), le plus récent → en tête. Auteure,
  // date et passages repris tels quels de la page publiée (texte transmis par Lucas).
  {
    outlet: "NeozOne",
    logo: "/press-neozone.png",
    logoClass: "h-7",
    title: "Et si vendre vos objets d'occasion permettait aussi de financer les associations ?",
    date: "2 novembre 2026",
    author: "Méline Kleczinski",
    quote:
      "Avec Gively, désencombrer sa maison devient aussi un geste solidaire !",
    url: "https://www.neozone.org/societe/et-si-vendre-vos-objets-doccasion-permettait-aussi-de-financer-les-associations/",
  },
  // 25/10/2026 (Lucas : « en premier ») : article de La Dépêche du Midi, vérifié à la
  // source (auteur, date et chapô repris tels quels de la page publiée).
  {
    outlet: "La Dépêche du Midi",
    logo: "/press-ladepeche.png",
    logoClass: "h-8",
    title:
      "« Le vendeur choisit le montant du don » : ce Toulousain lance une plateforme de vente d'occasion, une partie de chaque transaction est reversée à une association",
    date: "25 octobre 2026",
    author: "Anaëlle Petit",
    quote:
      "Elle se nomme Gively. Cette plateforme de vente de seconde main a été lancée il y a trois mois par Lucas Crampon, Toulousain de 28 ans.",
    url: "https://www.ladepeche.fr/2026/10/25/le-vendeur-choisit-le-montant-du-don-ce-toulousain-lance-une-plateforme-de-vente-doccasion-une-partie-de-chaque-transaction-est-reversee-a-une-13611900.php",
  },
  {
    outlet: "CRESS Occitanie",
    logo: "/press-cress-occitanie.png",
    logoClass: "h-8",
    title:
      "Gively, la marketplace solidaire toulousaine qui finance les associations à chaque vente",
    date: "1er juin 2026",
    author: "Chambre Régionale de l'Économie Sociale et Solidaire Occitanie",
    quote:
      "Gively s'inscrit pleinement dans les valeurs de l'ESS : économie circulaire, financement solidaire et impact local.",
    url: "https://www.cressoccitanie.org/Gively-la-marketplace-solidaire-toulousaine-qui-finance-les-associations-a",
  },
  {
    outlet: "PEXE · Annuaire national des éco-entreprises",
    logo: "/press-pexe.png",
    logoClass: "h-8",
    title:
      "Gively référencée dans l'Annuaire national des éco-entreprises (PEXE, avec l'ADEME et le ministère de la Transition écologique)",
    date: "octobre 2026",
    author: "PEXE — Les éco-entreprises de France",
    quote:
      "Trouvez les solutions françaises pour la transition écologique, énergétique et circulaire.",
    url: "https://annuaire.ecoentreprises-france.fr/sheet/gively/1505990",
  },
  {
    outlet: "La Tribune",
    logo: "/press-latribune.png",
    logoClass: "h-10",
    title:
      "À Toulouse, Gively lance un Vinted solidaire pour donner du sens à la vente d'occasion",
    date: "3 juin 2026",
    author: "Israa Lizati",
    quote:
      "Vendre ou acheter un objet d'occasion tout en finançant une association, c'est l'idée lancée par Lucas Crampon depuis Toulouse.",
    url: "https://www.latribune.fr/article/economie/agroconso/74001216842877/a-toulouse-gively-lance-un-vinted-solidaire-pour-donner-du-sens-a-la-vente-doccasion",
  },
  {
    outlet: "TOULÉCO",
    logo: "/press-touleco.png",
    title: "Avec Gively, un Vinted solidaire vient de naître en Occitanie",
    date: "19 mai 2026",
    author: "Matthias Hardoy",
    quote:
      "Acheter de la seconde main tout en donnant un coup de pouce à une association. C'est la promesse de la plateforme occitane Gively.",
    url: "https://www.touleco.fr/Article-Market-Place-Solidaire,51793",
  },
  {
    outlet: "PressReader",
    logo: "/press-pressreader.png",
    logoClass: "h-6",
    title: "Gively dans La Tribune — édition numérique sur PressReader",
    date: "4 juin 2026",
    author: "La Tribune (PressReader)",
    quote:
      "Retrouvez l'article de La Tribune consacré à Gively, le Vinted solidaire toulousain, dans l'édition numérique du 4 juin 2026.",
    url: "https://www.pressreader.com/france/la-tribune-france/20260604/281741276094201",
  },
  {
    outlet: "Melles750",
    logo: "/press-melles750.png",
    title:
      "Gively, la plateforme toulousaine qui transforme la seconde main en don aux associations",
    date: "20 mai 2026",
    author: "La rédaction",
    quote:
      "L'une des plus belles initiatives entrepreneuriales nées en Occitanie au printemps 2026.",
    url: "https://melles750.fr/articles/2026/2026-05-20-gively-plateforme-toulousaine-seconde-main-solidaire",
  },
];
